import {
    FETCH_NOTIFICATIONS_SUCCESS_ACTION,
    FETCH_UNREADNOTIFICATIONS_SUCCESS_ACTION,
    FETCH_SHOWNNOTIFICATIONS_SUCCESS_ACTION
  } from "./action";
  
  const initialState = {
    processing: false,
    error: false
  };
  
  export default function(state: any = initialState, action: Function) {
    switch (action.type) {
      case FETCH_NOTIFICATIONS_SUCCESS_ACTION:
        return {
          ...state,
          notifications:action.payload.rows,
          notificationCount:action.payload.count
        }

      case FETCH_UNREADNOTIFICATIONS_SUCCESS_ACTION:
        return {
          ...state,
          unreadnotificationsdata:action.payload.rows,
          unreadnotificationCount:action.payload.count
        }

      case FETCH_SHOWNNOTIFICATIONS_SUCCESS_ACTION:
        return {
          ...state,
          shownnotificationsdata:action.payload.rows,
          shownnotificationCount:action.payload.count
        }
      default:
        return {
          ...state
        };
    }
  }
  